import React, { useContext } from "react";
import { Row, Button, Tooltip, useBreakpoints } from "@narmi/design_system";
import ContextForm, { FormContext } from "../ContextForm";
import BackCancelButton from "../BackCancelButton";
import StickyProgressButtons from "../StickyProgressButtons";

const ProgressButtons = ({
  onBack,
  backLabel,
  onNext,
  nextLabel = "Next",
  kind = "primary",
  // Setting this property to true will disable the multiple click prevention that the loading state provides.
  dangerouslyDisableShowLoading,
  disabled,
  disableNext = false,
  hidePrev = false,
  backTooltip,
  nextTooltip,
  shouldHideInlineToasts = false,
  isNextLoading = false,
  nextTestId = "next",
  // Enable sticky mobile footer buttons (opt-in for AO pages)
  enableStickyMobile = false,
}) => {
  const formContext = useContext(FormContext);
  const { s: isDesktop } = useBreakpoints();

  // Use sticky footer on mobile if enabled
  if (!isDesktop && enableStickyMobile) {
    return (
      <StickyProgressButtons
        onBack={onBack}
        backLabel={backLabel}
        onNext={onNext}
        nextLabel={nextLabel}
        kind={kind}
        dangerouslyDisableShowLoading={dangerouslyDisableShowLoading}
        disabled={disabled}
        disableNext={disableNext}
        hidePrev={hidePrev}
        shouldHideInlineToasts={shouldHideInlineToasts}
        isNextLoading={isNextLoading}
        nextTestId={nextTestId}
        backTooltip={backTooltip}
        nextTooltip={nextTooltip}
      />
    );
  }

  const getNextButton = () => {
    const next = (
      <Button
        kind={kind}
        label={nextLabel}
        testId={nextTestId}
        disabled={disableNext}
        onClick={formContext ? () => {} : onNext}
        isLoading={isNextLoading}
      />
    );
    return nextTooltip ? <Tooltip text={nextTooltip}>{next}</Tooltip> : next;
  };
  const getBackButton = () => {
    if (hidePrev) return;
    const back = <BackCancelButton onBack={onBack} backLabel={backLabel} disabled={disabled} />;
    return backTooltip ? <Tooltip text={backTooltip}>{back}</Tooltip> : back;
  };
  return (
    <div className="progress-buttons">
      <Row justifyContent="space-between" alignItems="center">
        <Row.Item>{getBackButton()}</Row.Item>
        <Row.Item shrink>
          {formContext ? (
            <ContextForm.Action
              onSubmit={onNext}
              dangerouslyDisableShowLoading={dangerouslyDisableShowLoading}
              shouldHideInlineToasts={shouldHideInlineToasts}
            >
              {getNextButton()}
            </ContextForm.Action>
          ) : (
            getNextButton()
          )}
        </Row.Item>
      </Row>
    </div>
  );
};

export default ProgressButtons;
